import { Button } from '@/components/ui/button';

const API_BASE_URL = import.meta.env.VITE_STATIC_URL || '';

export default function ItemGrid({ 
  items, 
  handleItemSelect, 
  loading, 
  error, 
  itemKey = 'label',
  valuekey="value",
  emptyMessage = 'No items available',
  isBrands = false,
  gridClassName = 'grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-10 p-4 place-items-center xl:px- lg:px-12'
}) {
  if (loading) {
    return <div>Loading</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!items || items.length === 0) {
    return <div>{emptyMessage}</div>;
  }
  // console.log(items)
  // console.log(item.)
  return (
    <div className={gridClassName}>
      {items.map((item, index) => (
        <Button 
          key={index} 
          variant="default" 
          size="gridBtn"
          className="bg-white h-32 w-40"
          value={item.value} 
          onClick={() => handleItemSelect(item[valuekey] || item)}
        >
          <div className='flex flex-col justify-center items-center gap-2'>
            <img 
              src={`${API_BASE_URL}${item.iconUrl}`} 
              className="h-16 w-auto max-w-full object-contain" 
              alt={item[valuekey] || item} 
              style={{ objectFit: 'contain' }}
            />
            {(!isBrands || item[valuekey] === "Others") && (
              <p className='text-black pb-2'>{item[itemKey] || item}</p>
            )}
          </div>
        </Button>
      ))}
    </div>
  );
}



